export type MarkingSelectionAction =
  | { kind: "deselect" }
  | { kind: "select-city" }
  | { kind: "select-area"; drawingId: string };

// Decide qual sincronização disparar quando o usuário alterna uma marcação
// no seletor "Marcações" do relatório — mantém a estratégia de cada caso
// isolada para evitar um if/else aninhado em Report/index.tsx.
export function resolveMarkingSelectionAction(
  markingId: string,
  selectedMarkings: string[] | undefined,
  cityMarkingId: string
): MarkingSelectionAction {
  const wasIncluded = selectedMarkings?.includes(markingId) ?? false;

  if (wasIncluded) return { kind: "deselect" };
  if (markingId === cityMarkingId) return { kind: "select-city" };
  return { kind: "select-area", drawingId: markingId };
}
